<markant-icon-button
  icon="m_edit"
  (click)="isOpen = true"
></markant-icon-button>
<markant-platform-modal-bridge *ngIf="isOpen">
  <markant-dialog
    class="group-rename-dialog"
    [headTitle]="
      'dashboardOverview.groupAssignment.groupNameEditDialog.headline'
        | transloco
    "
    [open]="true"
    (close)="resetAndClose()"
  >
    <span class="body">
      {{
        'dashboardOverview.groupAssignment.groupNameEditDialog.text' | transloco
      }}
    </span>
    <markant-input
      class="group-name-input"
      data-cy="input-group-name-dialog"
      maxlength="50"
      [readonly]="isLoading"
      [formControl]="groupNameInput"
      [label]="
        'dashboardOverview.groupAssignment.groupNameEditDialog.inputLabel'
          | transloco
      "
      [outlined]="true"
      [showLabelHint]="true"
      [required]="true"
      [errorText]="
        groupNameInput.errors
          | formControlKeyError
            : 'error.validation'
            : groupNameInput.touched || groupNameInput.dirty
          | transloco
      "
      [error]="
        groupNameInput.errors
          | formControlError: groupNameInput.touched || groupNameInput.dirty
      "
      [helperCharacterCounter]="true"
    >
    </markant-input>
    <div slot="footer">
      <markant-button
        colorScheme="primary"
        variant="clear"
        [loading]="isLoading"
        (click)="resetAndClose()"
      >
        {{ 'common.cancel' | transloco }}
      </markant-button>
      <markant-button [loading]="isLoading" (click)="validateAndRenameGroup()">
        {{ 'common.approve' | transloco }}
      </markant-button>
    </div>
  </markant-dialog>
</markant-platform-modal-bridge>
